// builder.config.js

// You might place this anywhere else in your project
import '@vueform/builder/index.css';
import { defineConfig } from '@vueform/builder'

// builder.config.js
export default defineConfig({});